export default __webpack_public_path__ + "static/media/blue-ufo.9bf01ce7.svg";